module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Gb-Da-Eb.0ea92e51.png";